/* Offer bundle selector v3 (2026-09-29; v2 2026-09-26) for the optistasis_bundle block in snippets/product-info.liquid.
   Every displayed amount is calculated from integer cents in data attributes: pack price, pack size,
   subscription percentage and the automatic order discount. v1 multiplied every "$" it found in the copy
   by 0.9, which also rewrote the $80 threshold in prose. Nothing here edits numbers inside sentences.

   Public surface kept for other scripts:
     window.obsClick_atc(bid)  add the current selection to the cart (used by the sticky bar)
     window.obsSubMode[bid]    'onetime' | 'subscribe'
     window.obxState[bid]      { label, price, cents } of the current selection
     document event 'obx:change' with the same detail, fired on every change */
(function () {
  if (window.obxInit) return;
  window.obsSubMode = window.obsSubMode || {};
  window.obxState = window.obxState || {};

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* The same arithmetic Shopify applies: the selling-plan percentage is rounded to the cent, the
     automatic order discount is floored to the cent (measured, see the Liquid comment). */
  function quote(root, input, mode) {
    var price = +input.getAttribute('data-price');
    var qty = +input.getAttribute('data-qty') || 1;
    var subPct = +root.getAttribute('data-sub-pct') || 0;
    var base = mode === 'subscribe' ? Math.round(price * (100 - subPct) / 100) : price;
    var threshold = +root.getAttribute('data-threshold') || 0;
    var orderPct = +root.getAttribute('data-order-pct') || 0;
    var disc = threshold && base >= threshold ? Math.floor(base * orderPct / 100) : 0;
    return { qty: qty, base: base, disc: disc, final: base - disc, per: Math.round((base - disc) / qty) };
  }

  function mode(root) {
    var r = q(root, 'input[name^="obx-pt-"]:checked');
    return r ? r.value : 'onetime';
  }
  function selected(root) {
    return q(root, 'input[name^="obx-pack-"]:checked') || q(root, 'input[name^="obx-pack-"]');
  }

  /* v3 (2026-09-29): the only selling plan delivers every 2 months, which one bottle lasts. Multi-bottle
     packs are one-time only: hide the purchase-type choice, force one-time and say where subscribing lives. */
  function limitSubscription(root) {
    var pick = selected(root);
    var multi = !!pick && (+pick.getAttribute('data-qty') || 1) > 1;
    var pt = q(root, '.obx-pt');
    if (!pt) return;
    pt.hidden = multi;
    var note = q(root, '.obx-sub-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'obx-sub-note';
      note.textContent = 'Subscribe & save 10% is available on 1 bottle, delivered every 2 months.';
      pt.parentNode.insertBefore(note, pt.nextSibling);
    }
    note.hidden = !multi;
    if (multi) {
      var one = q(root, 'input[name^="obx-pt-"][value="onetime"]');
      if (one && !one.checked) one.checked = true;
    }
  }

  function render(root) {
    var bid = root.getAttribute('data-bid');
    limitSubscription(root);
    var m = mode(root);
    var servings = +root.getAttribute('data-servings') || 0;
    var orderPct = root.getAttribute('data-order-pct');
    var threshold = (+root.getAttribute('data-threshold') || 0) / 100;

    qa(root, 'input[name^="obx-pack-"]').forEach(function (input) {
      var row = input.closest('.obx-row');
      var x = quote(root, input, m);
      row.classList.toggle('is-on', input.checked);
      q(row, '[data-out]').textContent = money(x.final);
      var facts = q(row, '[data-facts]');
      if (facts && servings) facts.textContent = (x.qty * servings) + ' servings · about ' + (x.qty * 2) + ' months';
      var per = q(row, '[data-per]');
      if (per) per.textContent = money(x.per) + '/bottle';
      var day = q(row, '[data-day]');
      if (day && servings) day.textContent = Math.round(x.final / (x.qty * servings)) + '¢ a day';
      var note = q(row, '[data-note]');
      if (note) {
        note.hidden = !x.disc;
        if (x.disc) note.textContent = 'Includes ' + orderPct + '% off orders over $' + threshold.toFixed(0) +
          ', applied in cart' + (m === 'subscribe' ? ' to this order' : '');
      }
    });

    var input = selected(root);
    if (!input) return;
    qa(root, 'input[name^="obx-pt-"]').forEach(function (r) {
      r.closest('.obx-ptrow').classList.toggle('is-on', r.checked);
      var out = q(root, '[data-pt="' + r.value + '"]');
      if (out) out.textContent = money(quote(root, input, r.value).final);
    });
    var sel = quote(root, input, m);
    var terms = q(root, '[data-pt-terms]');
    if (terms) {
      var cad = terms.getAttribute('data-cadence') || '';
      terms.textContent = sel.qty + (sel.qty === 1 ? ' bottle, ' : ' bottles, ') + cad + ' · skip or cancel anytime';
    }

    window.obsSubMode[bid] = m;
    var packName = (q(input.closest('.obx-row'), '.obx-name') || {}).firstChild;
    var label = (packName ? packName.textContent.trim() : sel.qty + ' bottles') + (m === 'subscribe' ? ' · subscription' : '');
    var btntxt = document.getElementById('obs-btntxt-' + bid);
    if (btntxt && !btntxt.getAttribute('data-busy')) btntxt.textContent = 'Add to cart · ' + money(sel.final);
    var state = { bid: bid, label: label, price: money(sel.final), cents: sel.final };
    window.obxState[bid] = state;
    syncBar(state);
    try { document.dispatchEvent(new CustomEvent('obx:change', { detail: state })); } catch (e) {}
  }

  /* The sticky bar (layout/theme.liquid, driven by optistasis-body-a.js) shows the current pack and
     price, and its button adds that selection. Without this script it keeps its old scroll-to-selector
     behaviour, so nothing breaks if this file fails to load. */
  function syncBar(state) {
    var bar = document.getElementById('opt-shopnow-bar');
    var btn = document.getElementById('opt-shopnow-btn');
    if (!bar || !btn || btn.getAttribute('data-target') !== 'bundles') return;
    var meta = bar.querySelector('.opt-bar-meta');
    if (!meta) return;
    var sel = meta.querySelector('.opt-bar-sel');
    if (!sel) {
      sel = document.createElement('span');
      sel.className = 'opt-bar-sel';
      meta.appendChild(sel);
      ['.opt-bar-rating', '.opt-bar-guarantee'].forEach(function (s) { var el = meta.querySelector(s); if (el) el.style.display = 'none'; });
      var pb = bar.querySelector('.opt-bar-product-btn');
      if (pb) pb.setAttribute('aria-label', 'Change supply');
    }
    sel.innerHTML = '';
    var strong = document.createElement('strong');
    strong.textContent = state.price;
    var lbl = document.createElement('span');
    lbl.className = 'opt-bar-lbl';
    lbl.textContent = state.label + ' ·';
    sel.appendChild(lbl);
    sel.appendChild(strong);
    var ttl = bar.querySelector('.opt-bar-title'); if (ttl) ttl.textContent = 'Lymphatic Drainage Drops';
    btn.textContent = 'Add to cart';
    btn.setAttribute('aria-label', 'Add ' + state.label + ' to cart, ' + state.price);
    btn.setAttribute('data-obx-add', state.bid);
  }

  function sectionsToRefresh() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.id) ids.push(drawer.id);
    else if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.getElementById('cart-live-region-text')) ids.push('cart-live-region-text');
    return ids.filter(function (v, i, a) { return a.indexOf(v) === i; }).join(',');
  }
  function applySection(sections, sectionId, targetId) {
    var html = sections && sections[sectionId];
    if (!html) return;
    var temp = document.createElement('div');
    temp.innerHTML = html.trim();
    var fresh = temp.querySelector('#' + targetId) || temp.firstElementChild;
    var current = document.getElementById(targetId);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function showErr(bid, msg) {
    var el = document.getElementById('obs-err-' + bid);
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  window.obsErr = showErr;

  var busy = {};
  window.obsClick_atc = function (bid) {
    var root = document.getElementById('obs-' + bid);
    if (!root || busy[bid]) return;
    var input = selected(root);
    if (!input || !input.value) { showErr(bid, 'Please choose a supply.'); return; }
    var btn = document.getElementById('obs-btn-' + bid);
    var btntxt = document.getElementById('obs-btntxt-' + bid);
    busy[bid] = true;
    showErr(bid, '');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btntxt.setAttribute('data-busy', '1');
    btntxt.textContent = 'Adding…';

    var item = { id: parseInt(input.value, 10), quantity: 1 };
    var planId = root.getAttribute('data-plan-id');
    if (mode(root) === 'subscribe' && planId) item.selling_plan = parseInt(planId, 10);
    var body = { items: [item] };
    var sections = sectionsToRefresh();
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }

    function done(label) {
      busy[bid] = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (label) {
        btntxt.textContent = label;
        setTimeout(function () { btntxt.removeAttribute('data-busy'); render(root); }, 1800);
      } else {
        btntxt.removeAttribute('data-busy');
        render(root);
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status && d.status >= 400) {
          done();
          showErr(bid, d.description || d.message || 'Could not add to cart. Please try again.');
          return;
        }
        if (d.sections) {
          applySection(d.sections, 'cart-drawer', 'CartDrawer');
          applySection(d.sections, 'cart-drawer', 'shopify-section-cart-drawer');
          applySection(d.sections, 'cart-icon-bubble', 'cart-icon-bubble');
          applySection(d.sections, 'cart-icon-bubble', 'shopify-section-cart-icon-bubble');
          applySection(d.sections, 'cart-live-region-text', 'shopify-section-cart-live-region-text');
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ items: d.items || [], sections: d.sections });
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          var trigger = document.querySelector('#cart-icon-bubble, [data-cart-toggle], .js-drawer-open-right, .cart-drawer-toggle');
          if (trigger) trigger.click();
        }
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'optistasis-bundle', productVariantId: input.value, cartData: d }); } catch (e) {}
        }
        done('Added to cart ✓');
      })
      .catch(function () {
        done();
        showErr(bid, 'Something went wrong. Please try again.');
      });
  };

  window.obxInit = function (bid) {
    var root = document.getElementById('obs-' + bid);
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    /* ?pack=1|3|5 preselects that pack (for a one-bottle-default test on cold traffic). */
    var m = /[?&]pack=(\d+)/.exec(window.location.search);
    if (m) {
      qa(root, 'input[name^="obx-pack-"]').forEach(function (r) { if (r.getAttribute('data-qty') === m[1]) r.checked = true; });
    }
    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('obx-radio')) { showErr(bid, ''); render(root); }
    });
    var btn = document.getElementById('obs-btn-' + bid);
    if (btn) btn.addEventListener('click', function () { window.obsClick_atc(bid); });
    render(root);
  };
  /* Kept so older markup cached in a visitor's browser does not throw. */
  window.obsInit = window.obxInit;
})();
